import { useCallback, useState } from "react";
import { Typography } from "@mui/material";

import { createData } from "./helper";
import TransactionStyle from "./style";
import TransactionTable from "./Table";
import TransactionFilters from "./Filter";
import { defaultValues } from "./Filter";

import { IPaymentHistoryParams } from "@/api/types/payments";
import { usePaymentHistory } from "@/api/hooks/usePaymentHistory";
import DashboardHeader from "@/components/app/DashboardHeader";

export default function PaymentHistory() {
    const [params, setParams] = useState<IPaymentHistoryParams>({
        search: "",
        skip: 0,
        take: 10,
        filter: {
            plan: "",
            search: "",
            status: "",
            source: "",
            method: "",
        },
    });

    const { data: paymentsData, isFetching, isLoading } = usePaymentHistory(params);

    const Data = paymentsData?.data.items.map((item) => createData(item));
    const totalItems = paymentsData?.data.pagination.totalItems;

    const handleApply = (data: typeof defaultValues) => {
        setParams((prev) => {
            return {
                ...prev,
                search: data.search || "",
                filter: {
                    status: data.status || "",
                    source: data.source || "",
                    method: data.method || "",
                    plan: Number(data.plan) || "",
                },
            };
        });
    };

    const handleChange = useCallback(({ page, rowsPerPage }: { page?: number, rowsPerPage?: number }) => {
        setParams((prev) => {
            return {
                ...prev,
                skip: Number(page) * Number(rowsPerPage),
                take: rowsPerPage || 10,
            };
        });
    }, []);

    return (
        <TransactionStyle>
            <DashboardHeader title="Transaction History">
                <Typography>
                    You can see all the transactions in here and choose a user or plan to see the details of them.
                </Typography>
                <Typography>You Can Search on the User and Plan Name</Typography>
            </DashboardHeader>

            <TransactionFilters onApply={handleApply} />

            <TransactionTable
                data={Data || []}
                originalData={paymentsData?.data.items || []}
                isFetching={isFetching}
                isLoading={isLoading}
                page={Number(params.skip) / Number(params.take)}
                rowsPerPage={Number(params.take)}
                totalItems={totalItems || 0}
                onChange={handleChange}
            />
        </TransactionStyle>
    );
}
